import { PagePending } from "@/components/ui/PagePending";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/listing-review")({
  pendingComponent: PagePending,
  component: Outlet,
  beforeLoad: () => ({
    breadcrumb: "Listing Review",
  }),
});
